"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const BreadcrumbsDistro_vue_1 = __importDefault(require("./BreadcrumbsDistro.vue"));
const PageHeadingDistro_vue_1 = __importDefault(require("./PageHeadingDistro.vue"));
const DistroSlider_vue_1 = __importDefault(require("./DistroSlider.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let DistroToolHeader = class DistroToolHeader extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorManager = new ColorLibController_1.default();
        this.sliderItemsFilter = [];
        this.textSearch = '';
        this.categoriesLibrary = this.colorManager.rateCategoryLibrary();
        this.filterCategoryCurrent = '';
        this.openFilter = false;
        this.arrayCategories = [];
        this.isSample = false;
        this.count = 0;
    }
    get categories() {
        const array = this.categoriesLibrary.map((cat) => {
            return Object.assign(Object.assign({}, cat), { count: 0 });
        });
        for (const item of this.sliderItems.sliderItems) {
            if (item.category === 'A++')
                array[0].count += 1;
            if (item.category === 'A+')
                array[1].count += 1;
            if (item.category === 'A')
                array[2].count += 1;
            if (item.category === 'B')
                array[3].count += 1;
            if (item.category === 'C')
                array[4].count += 1;
            if (item.category === 'D')
                array[5].count += 1;
        }
        return array;
    }
    get hasCategories() {
        return this.arrayCategories.length > 0;
    }
    categoryTransform(category) {
        return this.colorManager.getAlphaCategory(category);
    }
    isSampleSelected(code) {
        return this.arrayCategories.includes(code);
    }
    changeIsSampleSelected(newValue, code) {
        this.pushFn(code);
    }
    pushFn(sampleCode) {
        if (this.arrayCategories.includes(sampleCode)) {
            this.arrayCategories = this.arrayCategories.filter((item) => item !== sampleCode);
        }
        else {
            // @ts-ignore
            this.arrayCategories.push(sampleCode);
        }
        let notRepeat = [];
        notRepeat = this.arrayCategories.filter((item, index) => {
            return this.arrayCategories.indexOf(item) === index;
        });
        const dataArr = new Set(notRepeat);
        const result = [...dataArr];
        this.arrayCategories = result;
        this.filterCategory();
    }
    changeAreaInfo(value) {
        this.$emit('areaInfo', value);
    }
    f() {
        if (this.arrayCategories.length < 1 && this.count === 0) {
            for (const iterator of this.sliderItems.sliderItems) {
                if (!this.sliderItemsFilter.includes(iterator)) {
                    this.sliderItemsFilter.push(iterator);
                }
            }
        }
        this.count += 1;
    }
    emitNewCurrentId(newCurrentId, newAreaId) {
        this.$emit('newCurrentId', newCurrentId, newAreaId);
    }
    filterCategory() {
        this.textSearch = '';
        if (this.hasCategories) {
            this.sliderItemsFilter = this.sliderItems.sliderItems.filter((item) => {
                return this.arrayCategories.includes(item.category);
            });
        }
        else {
            this.sliderItemsFilter = this.sliderItems.sliderItems;
        }
    }
    onSearchChange(f) {
        this.arrayCategories = [];
        this.openFilter = false;
        this.textSearch = f;
        this.filterCategoryCurrent = '';
        if (f.length > 0) {
            this.sliderItemsFilter = this.sliderItems.sliderItems
                .filter((item) => {
                var _a;
                return item.area.areaName
                    .toLowerCase()
                    .trim()
                    .includes(f.trim().toLowerCase()) ||
                    item.category
                        .toLowerCase()
                        .trim()
                        .includes(f.trim().toLowerCase()) ||
                    ((_a = item.crop) === null || _a === void 0 ? void 0 : _a.name.toLowerCase().trim().includes(f.trim().toLowerCase())) ||
                    item.score
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(f.trim().toLowerCase()) ||
                    item.country.toLowerCase().trim().includes(f.trim().toLowerCase());
            })
                .map((sam) => sam);
            this.sliderItemsFilter = this.sliderItemsFilter.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id));
        }
        else {
            this.sliderItemsFilter = this.sliderItems.sliderItems;
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], DistroToolHeader.prototype, "sliderItems", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], DistroToolHeader.prototype, "currentSliderItemId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], DistroToolHeader.prototype, "isLoading", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('sliderItems.sliderItems')
], DistroToolHeader.prototype, "f", null);
DistroToolHeader = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BreadcrumbsDistro: BreadcrumbsDistro_vue_1.default,
            PageHeadingDistro: PageHeadingDistro_vue_1.default,
            DistroSlider: DistroSlider_vue_1.default,
            Search: bmk_ui_framework_1.Search,
            Tag: bmk_ui_framework_1.Tag,
            Separator: bmk_ui_framework_1.Separator,
            Filter: lucide_vue_next_1.Filter,
            CheckBox: bmk_ui_framework_1.CheckBox,
            X: lucide_vue_next_1.X,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
        },
    })
], DistroToolHeader);
exports.default = DistroToolHeader;
